const unescape = (htmlString: string) => (
  htmlString
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&#0?39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&') // Must happen last or else it will unescape other characters in the wrong order.
);

export function htmlUnescape(strings: any, ...values: any) {
  if (!strings) return '';
  if (typeof strings === 'string') {
    return unescape(strings);
  }

  let output = strings[0];
  for (const [index, value] of values.entries()) {
    output = output +  + strings[index + 1];
  }

  return output;
}
